/**
 * NavigationTracker - Simple navigation tracking utilities
 * 
 * Provides navigation-specific tracking functionality.
 * Deduplication is handled at the EventQueue level.
 */
export class NavigationTracker {
  private isStrictMode: boolean = false

  constructor() {
    this.detectStrictMode()
  }

  private detectStrictMode() {
    // Detect if we're in React StrictMode by checking for double effect execution
    let effectCount = 0
    const testEffect = () => {
      effectCount++
      if (effectCount > 1) {
        this.isStrictMode = true
      }
    }
    
    // Simple detection mechanism
    testEffect()
    setTimeout(testEffect, 0)
  }

  /**
   * Track navigation event - always allow, let EventQueue handle deduplication
   */
  shouldTrackNavigation(fromPath: string, toPath: string, method: string, eventType: 'trackNavigation' | 'trackCustomEvent' = 'trackNavigation'): boolean {
    return true // Let EventQueue handle deduplication
  }

  /**
   * Track tool loading - always allow, let EventQueue handle deduplication
   */
  shouldTrackToolLoading(toolName: string, stepName?: string, stepNumber?: number, properties?: Record<string, any>): boolean {
    return true // Let EventQueue handle deduplication
  }

  /**
   * Get current strict mode status
   */
  getStrictModeStatus(): boolean {
    return this.isStrictMode
  }
}

// Export singleton instance
export const navigationTracker = new NavigationTracker()
